// extracted by mini-css-extract-plugin
export var logo = "JustworksHeader-module--logo--2NW3_";